module.exports = __webpack_public_path__ + "img/المان-مرتبط.73ece43b.jpg";